import { Avatar, Button, Col, notification, Row, Space } from "antd";
import React from "react";
import ReusableTable from "../../../components/TableComponent";
import { FormColumnConfig, MasterConfigs } from "../../../interfaces/entity";
import HeadingSubHeading from "../../../components/ViewHeading/HeadingSubHeading";
import { leavesConfirg } from "../../../entity/leaves/leavesConfig";
import FormSetup from "../../../components/Forms/FormSetup";
import { useDispatch } from "react-redux";
import { putData } from "../../../actions/developer";
import { FormInstance } from "antd/lib";


const ApprovalLeaves = () => {
    const [open, setOpen] = React.useState(false);
    const [id, setId] = React.useState(null);
    const [userId, setUserId] = React.useState(null);
    const [form, setForm] = React.useState<FormInstance<any>>(null);
    const dispatch = useDispatch();
    const [leaveType, setLeaveType] = React.useState(null);

    const overideConfig: MasterConfigs = {
        ...leavesConfirg,
        getColumns: () => {
            return [
                {
                    title: 'Leave applied by',
                    dataIndex: 'user',
                    key: 'user',
                    fixed: 'left',
                    width: 200,
                    render: (text) => {
                        return <Space direction="horizontal">
                            <Avatar src={`${process.env.FILE_URL}${text.avatar}`} shape="circle" size={"default"} />
                            <Space direction="vertical" size={0}>
                                <h4 className="font-semibold m-0">{text?.firstName + ' ' + text?.lastName}</h4>
                                <h4 className="m-0">{text?.employeeId}</h4>
                            </Space>
                        </Space>
                    }
                },
                ...leavesConfirg.getColumns(),
                {
                    title: 'Actions',
                    dataIndex: '',
                    key: '',
                    align: 'center',
                    width: 100,
                    fixed: 'right',
                    render: (text, record) => {
                        return ['approved', 'rejected'].includes(record.leaveStatus) ? '' : <Space direction="horizontal">
                            <Button type="link" onClick={() => {
                                setUserId(record.user?._id)
                                setId(record._id)
                                setLeaveType(record?.leaves?._id)
                                if (form) {
                                    form.setFieldsValue({
                                        leaveType: record?.leaves?._id,
                                    });
                                }
                                setOpen(true)
                            }}>Action</Button>
                        </Space>
                    }
                }
            ]
        }
    }

    const approveReject: MasterConfigs = {
        api: () => `/leaves/approve/reject/leave`,
        modalTitle: () => 'Approve/Reject Leave',
        getFormColumns: () => {
            return [
                {
                    type: "select",
                    label: "Leave Type",
                    name: "leaveType",
                    isCombo: true,
                    span: 16,
                    rules: [{ required: true, message: "Please select a leave type" }],
                },
                {
                    label: 'Approve/Reject',
                    name: 'leaveStatus',
                    type: 'select',
                    children: [
                        { name: 'Approve', value: 'approved' },
                        { name: 'Reject', value: 'rejected' }
                    ],
                    rules: [{ required: true, message: 'Please select Approve/Reject!' }],
                    span: 8
                },
                {
                    type: 'custom',
                    span: 16,
                },
                {
                    label: 'Comment',
                    name: 'comment',
                    type: 'textarea',
                    span: 16,
                    rules: [{ required: true, message: 'Please enter your comment!' }]
                }
            ] as FormColumnConfig[]
        },

        setForm: (formInstance) => {
            setForm(formInstance)
            if (formInstance)
                formInstance?.setFieldsValue({
                    leaveType: leaveType,
                });
        },
        onSubmit: (id, data) => {
            return onSubmit(data)
        },
        combo: [
            {
                name: "leaveType",
                api: userId ? `/leaves/user/leaves/list/?userId=${userId}` : undefined,
                idKey: (e) => e?._id,
                render: (e) => `${e?.leaveType?.leaveName} - (${e?.available})`,
            }
        ]

    }

    const onRefresh = () => {
        dispatch({
            type: 'REFRESH_TABLE',
            refreshTable: true,
            query: {}
        })
    }

    const onSubmit = async (data) => {
        try {
            console.log(data)
            const resData = putData(`${approveReject.api()}/${id}`, data);
            const response = await dispatch(resData);
            if (response) {
                onRefresh()
                return {
                    code: 200,
                    ...response
                }
            } else {
                return response
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            notification.error({ message: 'Error', description: 'Error while submitting data' })
        }
    }

    return <Row gutter={[16, 16]}>
        <FormSetup open={open} config={approveReject} onClose={() => {
            setOpen(false)
            setId(null)
            setUserId(null)
            setLeaveType(null)
        }} isModal={true} form={setForm} />
        <Col span={24}>
            <HeadingSubHeading title="Approval Leaves" titleProps={{ level: 5 }} />
        </Col>
        <Col span={24}>
            <ReusableTable config={overideConfig} />
        </Col>
    </Row>
};

export default ApprovalLeaves;